import React from 'react';
import TabsMenuItemStyled from './bundle.esm2.js';

const TabsMenuItem = (props) => {
  const { icon, title, className, onClick } = props;
  const getIcon = () => {
    if (typeof icon === "string") {
      return /* @__PURE__ */ React.createElement("img", {
        src: icon,
        alt: title,
        className: "TabsMenuItem__icon"
      });
    }
    const Icon = icon;
    return /* @__PURE__ */ React.createElement(Icon, {
      className: "TabsMenuItem__icon"
    });
  };
  return /* @__PURE__ */ React.createElement(TabsMenuItemStyled, {
    className: `TabsMenuItem ${className}`,
    onClick,
    title
  }, getIcon(), /* @__PURE__ */ React.createElement("p", {
    className: "TabsMenuItem__title"
  }, title));
};
TabsMenuItem.defaultProps = {
  className: ""
};

export { TabsMenuItem as default };
//# sourceMappingURL=bundle.esm.js.map
